module.exports = __webpack_public_path__ + "img/register.efcc6e66.svg";